import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { UtilFns } from '@utils';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AuthService } from '../../services/auth.service';
import { passwordMeetsRules, PasswordRulesComponent } from './password-rules.component';

@Component({
  templateUrl: './new-password.component.html',
  styleUrls: ['./auth-shell.scss'],
  imports: [InputTextModule, ButtonModule, FormsModule, RouterModule, PasswordModule, PasswordRulesComponent],
})
export class NewPasswordComponent implements OnInit {
  passwordMeetsRules = passwordMeetsRules;
  error = '';
  success = '';
  working = false;
  email = '';
  code = '';
  newpassword = '';
  conpassword = '';
  /** Set when the user arrived straight from confirming their email, not from Forgot Password. */
  justConfirmed = false;
  /** Set when the link cannot be used, so the page offers a new one. */
  linkFailed = false;

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    const params = UtilFns.parseUrlParams(location);
    this.code = params.get('code') || '';
    this.email = params.get('email') || '';
    this.justConfirmed = params.get('confirmed') === '1';

    if (!this.code || !this.email) {
      this.error = 'This reset link is not complete. Copy the full link from the email.';
      this.linkFailed = true;
    }
  }

  async onSubmit() {
    this.error = '';
    if (this.conpassword != this.newpassword) {
      this.error = "Passwords do not match";
      return;
    }
    if (this.working || this.success || !passwordMeetsRules(this.newpassword)) { return; }

    this.working = true;
    try {
      await this.authService.resetPassword(this.email, this.code, this.newpassword);
      this.error = '';
      this.success = 'Password has been reset';
      this.working = false;
      setTimeout(() => this.router.navigateByUrl('/'), 3000);

    } catch (err: any) {
      if (err.status === 0) {
        this.error = 'Unable to contact server';
      } else {
        //   this._logger.log(error, 'error');
        this.error = UtilFns.getErrorMessage(err);
        // A 400 means the link is too old or already used; only a new email fixes that.
        this.linkFailed = err.status === 400;
      }
      this.working = false;
    }

  }

}
